import { cn } from '@/lib/utils/utils';

/**
 * QR Code statique Horodaty (lien vers téléchargement app)
 * @param {Object} props
 * @param {string} [props.className] - Classes CSS additionnelles
 * @param {number} [props.size=100] - Taille du QR code en pixels
 */
export function QRCodeHorodaty({ className, size = 100, ...props }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 120 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={cn(className)}
            {...props}
        >
            <rect width="120" height="120" fill="white" />
            {/* Position markers */}
            <rect x="8" y="8" width="24" height="24" fill="black" />
            <rect x="12" y="12" width="16" height="16" fill="white" />
            <rect x="16" y="16" width="8" height="8" fill="black" />
            <rect x="88" y="8" width="24" height="24" fill="black" />
            <rect x="92" y="12" width="16" height="16" fill="white" />
            <rect x="96" y="16" width="8" height="8" fill="black" />
            <rect x="8" y="88" width="24" height="24" fill="black" />
            <rect x="12" y="92" width="16" height="16" fill="white" />
            <rect x="16" y="96" width="8" height="8" fill="black" />
            {/* Data modules */}
            <rect x="40" y="8" width="4" height="4" fill="black" />
            <rect x="48" y="8" width="4" height="4" fill="black" />
            <rect x="56" y="8" width="4" height="4" fill="black" />
            <rect x="72" y="8" width="4" height="4" fill="black" />
            <rect x="40" y="16" width="4" height="4" fill="black" />
            <rect x="56" y="16" width="4" height="4" fill="black" />
            <rect x="64" y="16" width="4" height="4" fill="black" />
            <rect x="72" y="16" width="4" height="4" fill="black" />
            <rect x="40" y="24" width="4" height="4" fill="black" />
            <rect x="48" y="24" width="4" height="4" fill="black" />
            <rect x="64" y="24" width="4" height="4" fill="black" />
            <rect x="72" y="24" width="4" height="4" fill="black" />
            <rect x="40" y="40" width="4" height="4" fill="black" />
            <rect x="48" y="40" width="4" height="4" fill="black" />
            <rect x="56" y="40" width="4" height="4" fill="black" />
            <rect x="64" y="40" width="4" height="4" fill="black" />
            <rect x="72" y="40" width="4" height="4" fill="black" />
            <rect x="88" y="40" width="4" height="4" fill="black" />
            <rect x="96" y="40" width="4" height="4" fill="black" />
            <rect x="104" y="40" width="4" height="4" fill="black" />
            <rect x="40" y="48" width="4" height="4" fill="black" />
            <rect x="56" y="48" width="4" height="4" fill="black" />
            <rect x="72" y="48" width="4" height="4" fill="black" />
            <rect x="88" y="48" width="4" height="4" fill="black" />
            <rect x="104" y="48" width="4" height="4" fill="black" />
            <rect x="40" y="56" width="4" height="4" fill="black" />
            <rect x="48" y="56" width="4" height="4" fill="black" />
            <rect x="64" y="56" width="4" height="4" fill="black" />
            <rect x="80" y="56" width="4" height="4" fill="black" />
            <rect x="96" y="56" width="4" height="4" fill="black" />
            <rect x="104" y="56" width="4" height="4" fill="black" />
            <rect x="40" y="64" width="4" height="4" fill="black" />
            <rect x="56" y="64" width="4" height="4" fill="black" />
            <rect x="64" y="64" width="4" height="4" fill="black" />
            <rect x="80" y="64" width="4" height="4" fill="black" />
            <rect x="96" y="64" width="4" height="4" fill="black" />
            <rect x="104" y="64" width="4" height="4" fill="black" />
            <rect x="40" y="72" width="4" height="4" fill="black" />
            <rect x="48" y="72" width="4" height="4" fill="black" />
            <rect x="64" y="72" width="4" height="4" fill="black" />
            <rect x="72" y="72" width="4" height="4" fill="black" />
            <rect x="88" y="72" width="4" height="4" fill="black" />
            <rect x="96" y="72" width="4" height="4" fill="black" />
            <rect x="40" y="88" width="4" height="4" fill="black" />
            <rect x="48" y="88" width="4" height="4" fill="black" />
            <rect x="56" y="88" width="4" height="4" fill="black" />
            <rect x="72" y="88" width="4" height="4" fill="black" />
            <rect x="88" y="88" width="4" height="4" fill="black" />
            <rect x="96" y="88" width="4" height="4" fill="black" />
            <rect x="104" y="88" width="4" height="4" fill="black" />
            <rect x="40" y="96" width="4" height="4" fill="black" />
            <rect x="56" y="96" width="4" height="4" fill="black" />
            <rect x="64" y="96" width="4" height="4" fill="black" />
            <rect x="80" y="96" width="4" height="4" fill="black" />
            <rect x="88" y="96" width="4" height="4" fill="black" />
            <rect x="104" y="96" width="4" height="4" fill="black" />
            <rect x="40" y="104" width="4" height="4" fill="black" />
            <rect x="48" y="104" width="4" height="4" fill="black" />
            <rect x="64" y="104" width="4" height="4" fill="black" />
            <rect x="72" y="104" width="4" height="4" fill="black" />
            <rect x="88" y="104" width="4" height="4" fill="black" />
            <rect x="96" y="104" width="4" height="4" fill="black" />
            <rect x="104" y="104" width="4" height="4" fill="black" />
        </svg>
    );
}
